import { createFileRoute } from '@tanstack/react-router';

import { SupplyAppsLayout } from '../features/supply/apps/components/SupplyAppsLayout';

export const Route = createFileRoute('/supply/apps')({
  component: SupplyAppsLayout,
});
